import React, { Fragment, useEffect, useRef, useState } from 'react'

import withFloor from '../../../../components/withFloor'
import ReservPage from './component/detailSub/reserv'
import EstimatePage from './component/detailSub/estimate'
import InfoPage from './component/detailSub/info'
import AuthPage from './component/detailSub/auth'
import G from '../../../../util/globalFunction'
import Guard from '../../../../components/guard'
import * as R from 'ramda'

import tremApi from '../../../../util/tremApi'
import tremSession from '../../../../util/tremSession'
import TF from '../../../../util/tremFunction'
import Cookies from 'js-cookie'

const reservListDef = [
    {
        TARGET_NAME: G.t('trem.lang.home.0399'), //서울바이오허브
        EQ_ROOM_SKEY: 1,
        ATTR_SKEY: 1,
    },
    {
        TARGET_NAME: G.t("trem.lang.home.0416"), //서울 바이오 혁신커뮤니티센터
        EQ_ROOM_SKEY: 1,
        ATTR_SKEY: 2,
    },
    // 2025.03.04 삭제 요청 - rotbilly
    // {
    //     TARGET_NAME: G.t("trem.lang.home.0427"), //서울 바이오 산학협력센터
    //     EQ_ROOM_SKEY: 1,
    //     ATTR_SKEY: 3,
    // },
    {
        TARGET_NAME: G.t("trem.lang.home.0431"), //BT-IT융합센터
        EQ_ROOM_SKEY: 1,
        ATTR_SKEY: 4,
    }
]

let teb_sub='';

const WrappedPage = props => {

    const params = props.params

    const pageParams = props.params.pageParams

    //스크롤 이벤트
    const [scrollFlag, setScrollFlag] = useState(false)
    const scrollRef = useRef(scrollFlag)
    const onScroll = () => {
        if(window.scrollY > 200 && !scrollRef.current) {
            setScrollFlag(true)
            scrollRef.current = true
        }
        if(window.scrollY <= 200 && scrollRef.current) {
            setScrollFlag(false)
            scrollRef.current = false
        }
    }
    useEffect(async () => {
        window.addEventListener('scroll', onScroll)
        if(!R.isNil(params.EQUIP_SKEY)){
            const data = await tremApi('/r/hm/equipReservation/detail', {
                EQUIP_SKEY: params.EQUIP_SKEY,
                EQ_ROOM_SKEY: params.EQ_ROOM_SKEY || 1,
                ATTR_SKEY: params.ATTR_SKEY || 1,
                REGIST_DT: 1,
            }).then(data => {
                return data
            }).catch(err => {
                alert(G.t('trem.lang.home.0836'), err)/* 오류발생 */
            })
            setDataStore(data)
            setTabMenu(params.tabIdx)
            document.querySelectorAll(".tab_type1 li").forEach(function(v, i){
                if(i == params.tabIdx){
                    v.classList.add("active")
                }
            })
            
            teb_sub = params.tabIdx===0 ? G.t('trem.lang.home.0727')+"("+data.KOR_NM+")" : params.tabIdx===1 ? G.t('trem.lang.home.0010')+"("+data.KOR_NM+")" : params.tabIdx===2 ? G.t('trem.lang.home.0021')+"("+data.KOR_NM+")" :  params.tabIdx===3 ? G.t('trem.lang.home.0052')+"("+data.KOR_NM+")" :  ""
            document.title = G.t('trem.lang.home.0682') + " > " + G.t('trem.lang.home.0010') + " > " + teb_sub;
        }
        return () => window.removeEventListener('scroll', onScroll)
        
    }, [])

    //data
    const [dataStore, setDataStore] = useState({})
    //tab
    const [tabMenu, setTabMenu] = useState(R.isNil(params.tabIdx)?0:params.tabIdx);

    
    
    //click tab
    const clickTabMenu = async (Idx) => {

        const userSkey = await tremSession.getUserSkey()
        
        if(!userSkey) {
            alert(G.t('trem.lang.home.0697'), G.t('trem.lang.home.1137'), ()=>{G.gotoPage('/login')})/*로그인 후 이용가능합니다.*/
            return false
        }
        
        setTabMenu(Idx)

        teb_sub = Idx===0 ? G.t('trem.lang.home.0727')+"("+dataStore.KOR_NM+")" : Idx===1 ? G.t('trem.lang.home.0010')+"("+dataStore.KOR_NM+")" : Idx===2 ? G.t('trem.lang.home.0021')+"("+dataStore.KOR_NM+")" :  Idx===3 ? G.t('trem.lang.home.0052')+"("+dataStore.KOR_NM+")" :  ""

        document.title = G.t('trem.lang.home.0682') + " > " + G.t('trem.lang.home.0010') + " > " + teb_sub;
    }

    const currentLang = Cookies.get('__floor_lang__') || 'ko'

    return (
        <Fragment>
            <div className="sub_wrap">
                <div className={"navi_menu "+ (scrollFlag ? "fixed" : "")}>
                    <div className="inner">
                        <ul>
                            <li className="navi_home">
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage(`/`)}} onFocus={() => {document.getElementById("header").style.height = "110px"}}>{G.t('trem.lang.home.0000')}</a>{/* 홈 */}
                            </li>
                            <li className="navi_first">
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list")}}>{G.t('trem.lang.home.0010')}</a>{/* 장비예약 */}
                                {/*<a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list")}}>{G.t('trem.lang.home.0682')}</a>
                                <div>
                                    <a href="javascript:void(0);" onClick={()=>{G.gotoPage(`/home/event/list`)}}>{G.t('trem.lang.home.0018')}</a>{/* 교육/세미나 
                                    <a href="javascript:void(0);" onClick={()=>{G.gotoPage(`/home/board/notice/list`)}}>{G.t('trem.lang.home.0017')}</a>{/* 공지사항 
                                </div>*/}
                            </li>
                            {/*<li>
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list")}}>{G.t('trem.lang.home.0010')}</a>{/* 장비예약 
                                <div>
                                    {/* <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/cooperation/list")}}>{G.t('trem.lang.home.0691')}</a>
                                    <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/operation/pubFacility/list")}}>{G.t('trem.lang.home.0011')}</a>{/* 시설예약 
                                    <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/operation/carray/list")}}>{G.t('trem.lang.home.0201')}</a>{/* 반입물품예약 
                                    {/* <a onClick={()=>{G.gotoPage("/")}}>{G.t('trem.lang.home.0438')}</a> 
                                    {/* <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/operation/counsel/list")}}>{G.t('trem.lang.home.0215')}</a>{/* 상담신청현황 
                                    {/* <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/prototype/list")}}>{G.t('trem.lang.home.0259')}</a>시작품의뢰  
                                </div>
                            </li>*/}
                            <li className="navi_last">
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list", {EQ_ROOM_SKEY: pageParams?.EQ_ROOM_SKEY, ATTR_SKEY: (pageParams?.ATTR_SKEY == 1 ? 4 : pageParams?.ATTR_SKEY-1)})}} className="prev">{G.t('trem.lang.home.0345')}</a> {/* 이전 */}
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list", {EQ_ROOM_SKEY: pageParams?.EQ_ROOM_SKEY, ATTR_SKEY: (pageParams?.ATTR_SKEY == 4 ? 1 : pageParams?.ATTR_SKEY+1)})}} className="next">다음</a>
                                {reservListDef.filter(obj => obj.ATTR_SKEY === (pageParams?.ATTR_SKEY || 1) 
                                ).map(obj => {
                                    return <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list", {EQ_ROOM_SKEY: obj.EQ_ROOM_SKEY, ATTR_SKEY: obj.ATTR_SKEY})}} className="last_m">{obj.TARGET_NAME}</a>
                                })}
                                <ul>
                                    {reservListDef.filter(obj => obj.ATTR_SKEY != (pageParams?.ATTR_SKEY || 1) 
                                    ).map(obj => {
                                        return <li><a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list", {EQ_ROOM_SKEY: obj.EQ_ROOM_SKEY, ATTR_SKEY: obj.ATTR_SKEY})}}>{obj.TARGET_NAME}</a></li>
                                    })}
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>         
                <div className="inner" id="skip_con">
                    <div className="location">
                        <p>{G.t('trem.lang.home.0000')}{' > '}{G.t('trem.lang.home.0682')}{' > '}{G.t('trem.lang.home.0010')}</p>{/* 홈 > 시설·장비 예약 > 장비예약 */}
                        {/*
                        <ol>
                            <li>{G.t('trem.lang.home.0000')}</li>// 홈
                            <li>{G.t('trem.lang.home.0682')}</li>// 시설·장비 예약
                            <li>{G.t('trem.lang.home.0010')}</li>// 장비예약
                        </ol>
                        */}
                        <h2>{G.t('trem.lang.home.0010')}</h2>{/* 장비예약 */}
                        <div className="btn_box" >
                            <a title="링크복사" className="btn_link" href="javascript:void(0);" onClick={() => { TF.getPublicAddress("/home/equip/reserv/detail", `tabIdx=${tabMenu},EQUIP_SKEY=${params.EQUIP_SKEY},EQ_ROOM_SKEY=${params.EQ_ROOM_SKEY},ATTR_SKEY=${params.ATTR_SKEY}`)}}>링크복사</a>
                            {/* <a className="btn_help" onClick={() => { TF.goHelp("/hm/manual/equipReservation/detail")}}>도움말</a> */}
                        </div>
                    </div>
                    <div className={currentLang === 'ko' ? "e_reservation" : "e_reservation e_reservation_en"} style={{position:"relative"}}>
                        <div className="tab_type1">
                            <ul>
                                <li className={tabMenu===0 ? "active" : ""}>
                                    <h1 className='hidden'>{G.t('trem.lang.home.0727')}</h1>
                                    <a href="javascript:void(0);" title={tabMenu===0 ? "선택됨" : ""} onClick={() => clickTabMenu(0)}>{G.t('trem.lang.home.0727')}</a> {/* 장비정보 */}
                                </li>
                                {
                                    (dataStore?.SCHED_START_DT_STR || '') === '정상가동중' /*수리중x*/
                                    && (dataStore?.OPER_LIST || []).length > 0 /*옵션 set*/
                                    && (dataStore?.USE_SCOPE_CD != "1" && (dataStore?.FLAG_PUBLIC || "Y") == "Y") /*단독활용x 예약허용o*/
                                    && (dataStore?.FIR_FLAG != "N" && dataStore?.OVER_FIR_APPLY_YN != "Y")
                                    ? <Fragment>
                                        <li className={tabMenu===1 ? "active" : ""}>
                                            <a href="javascript:void(0);" title={tabMenu===1 ? "선택됨" : ""} onClick={() => clickTabMenu(1)}>{G.t('trem.lang.home.0010')}</a>{/* 장비예약 */}
                                        </li>
                                        <li className={tabMenu===2 ? "active" : ""}>
                                            <a href="javascript:void(0);" title={tabMenu===2 ? "선택됨" : ""} onClick={() => clickTabMenu(2)}>
                                                {G.t('trem.lang.home.0021')}{/* 견적서 */}
                                            </a>
                                        </li>
                                    </Fragment>
                                    : <Fragment></Fragment>
                                }
                                
                                { /*수리중*/
                                    (dataStore?.SCHED_START_DT_STR || '') != '정상가동중' 
                                    && <Fragment>
                                        <li className={tabMenu===2 ? "active" : ""}>
                                            <a  href="javascript:void(0);" title={tabMenu===2 ? "선택됨" : ""} onClick={() => clickTabMenu(2)}>
                                                {G.t('trem.lang.home.0021')}{/* 견적서 */}
                                            </a>
                                        </li>
                                    </Fragment>
                                }
                                <li className={tabMenu===3 ? "active" : ""}>
                                    <a href="javascript:void(0);" title={tabMenu===3 ? "선택됨" : ""} onClick={() => clickTabMenu(3)}>{G.t('trem.lang.home.0052')}</a>{/* 이용권한 */}
                                </li>
                            </ul>
                        </div> 
                        <div className="reser_con">
                            {
                                {
                                    0: <InfoPage params={props.params} setTabMenu={setTabMenu}/>, //장비정보
                                    1: <ReservPage params={dataStore}/> , //장비예약
                                    2: <EstimatePage params={dataStore} setTabMenu={setTabMenu}/> , //견적서
                                    3: <AuthPage params={props.params} setTabMenu={setTabMenu}/>  //이용권한
                                }[tabMenu]
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

const title = G.t('trem.lang.home.0682') + " > " + G.t('trem.lang.home.0010')  + " > " + teb_sub/* 시설·장비 예약 > 장비예약 */
const layout = true
const layoutMode = 'public'
export default withFloor({title, layout, layoutMode})(WrappedPage)